import type { FunctionComponent } from 'react';
import type { TypeClusterProps } from './types';

/**
 * Cluster
 */
export const Cluster: FunctionComponent<TypeClusterProps> = ({
  className = '',
  children,
  cluster,
  superCluster,
  lat,
  lng,
  mapRef,
  count,
}: TypeClusterProps) => (
  <div
    className={`
        flex h-10 w-10 -translate-x-1/2 -translate-y-1/2 cursor-pointer items-center justify-center rounded-full p-2.5 text-neutrals-0
        ${
          count > 10
            ? 'bg-gradient-radial from-primary-600 via-primary-500'
            : 'bg-gradient-radial from-primary-500 via-primary-400'
        }
        ${className}
    `}
    onClick={() => {
      const expansionZoom = Math.min(
        superCluster.getClusterExpansionZoom(cluster.id),
        20
      );
      mapRef?.current?.setZoom(expansionZoom);
      mapRef?.current?.panTo({ lat, lng });
    }}
  >
    {children ?? count}
  </div>
);

Cluster.displayName = 'Cluster';
